module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"submitSuccess":"Results for contestant #%{number} was updated in the database","dialogTitle":"Input results for contestant"},"no":{"submitSuccess":"Resultater ble satt for deltaker #%{number} i databasen","dialogTitle":"Angi resultater for deltaker"}}')
  delete Component.options._Ctor
}
